import { shareInfoService } from '@/services';
import ShareInfoVM from '@/view-model/share-management/ShareInfoVM';
import { IShareInfoActionTypes, } from '@/vuex-store/share-management/share-list/types';
import ShareInfoConfigVM from '@/view-model/share-management/ShareInfoConfigVM';
import { shareInfoStatusTypeCode } from '@/constants/shareManagement/shareInfoStatusOptionList';
const action = {
    [IShareInfoActionTypes.setFilterOption]({ commit }, options) {
        commit('SET_FILTER_OPTION', options);
    },
    [IShareInfoActionTypes.setShareInfoSortOptions]({ commit }, options) {
        commit('SET_SHARE_INFO_SORT_OPTIONS', options);
    },
    async [IShareInfoActionTypes.getShareInfo]({ getters, commit, rootGetters, }) {
        try {
            const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
            const distributorId = rootGetters['hubSelector/getterSubscribeDistributorHubId'];
            const hubStatus = getters.getterShareInfoStatusType === shareInfoStatusTypeCode[0]
                ? ''
                : getters.getterShareInfoStatusType;
            const param = {
                hubId: distributorId ?? hubId,
                hubStatus,
                hubName: getters.getterSearchWordValue,
            };
            const { data } = await shareInfoService.getShareInfo(param);
            // @ts-ignore
            const list = new ShareInfoVM(data);
            commit('GET_SHARE_INFO', list);
        }
        catch (error) {
            console.log('[shareHubManagement/shareList/getShareInfo]', error);
        }
    },
    async [IShareInfoActionTypes.getShareStoreList]({ commit, rootGetters }, agencyHubId = '') {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const distributorId = rootGetters['hubSelector/getterSubscribeDistributorHubId'];
        const { data } = await shareInfoService.getShareInfoConfig({
            hubId: distributorId ?? hubId,
            agencyHubId,
        });
        const shareInfo = new ShareInfoConfigVM(data);
        commit('GET_SHARE_STORE_LIST', shareInfo.formattedStores);
    },
    [IShareInfoActionTypes.resetShareInfo]({ commit }) {
        commit('RESET_SHARE_INFO');
    },
    [IShareInfoActionTypes.resetShareStoreList]({ commit }) {
        commit('RESET_SHARE_STORE_LIST');
    },
    [IShareInfoActionTypes.setSelectedRowShareInfo]({ commit }, hubId) {
        commit('SET_SELECTED_ROW_SHARE_INFO', hubId);
    },
};
export default action;
